/**
 * Página de Exemplo: Formulário Interativo
 * Demonstra como integrar FormularioPreCadastro na aplicação
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import { FormularioPreCadastro } from '@/components/FormularioPreCadastro';

/**
 * Página que renderiza o formulário interativo
 * Pode ser acessada em uma rota dedicada como:
 * /pre-cadastro
 * /formulario
 * /seja-revendedora
 * /revender/:indicatedCode (opcional - código do indicador)
 */
export const FormularioPage: React.FC = () => {
  const { indicatedCode } = useParams<{ indicatedCode?: string }>();
  
  return (
    <div className="formulario-page">
      <FormularioPreCadastro indicatedCode={indicatedCode} />
    </div>
  );
};

export default FormularioPage;

/**
 * Exemplo de como usar em App.tsx ou Router:
 *
 * import { FormularioPage } from '@/pages/FormularioPage';
 *
 * const routes = [
 *   {
 *     path: '/formulario',
 *     element: <FormularioPage />
 *   },
 *   {
 *     path: '/pre-cadastro',
 *     element: <FormularioPage />
 *   }
 * ];
 */
